import * as React from 'react';

import styles from './styles.css';

interface IControlTooltipProp {
  text: string | null;
}

export const ControlTooltip: React.FC<IControlTooltipProp> = ({ text }) => {
  return <div className={styles['container']}>{text}</div>;
};
